import { selectBestsellers } from 'containers/configurators-listing/selectors';
import { Typography } from 'fronton-react/typography';
import React from 'react';
import { useSelector } from 'react-redux';
import { BestsellerCard } from './components/bestseller-card';
import { GoToAllServicesCard } from './components/go-to-all-services-card';
import { BestSellersContainer, TitleWrapper } from './styled';

export const Bestsellers = () => {
	const bestsellers = useSelector(selectBestsellers);

	const MAX_SERVICES_TO_SHOW = 7;

	const services =
		!!bestsellers.length &&
		bestsellers
			.filter(bestseller => bestseller.type !== 'measurement')
			.slice(0, MAX_SERVICES_TO_SHOW);

	return (
		<>
			<TitleWrapper id="bestsellers">
				<Typography as="p" variant="h2">
					Доступные услуги
				</Typography>
			</TitleWrapper>

			<BestSellersContainer>
				{!!services.length &&
					services.map(bestseller => (
						<BestsellerCard
							key={`bestseller-card-${bestseller.id}`}
							bestseller={bestseller}
						/>
					))}
				<GoToAllServicesCard />
			</BestSellersContainer>
		</>
	);
};
